export const BOT_SETUP_GUIDE_URL = 'https://sportspredict.com/probability/api';

export const PRESTART_SUBSTACK_SUBSCRIBE_URL =
	'https://sportspredictcom.substack.com/subscribe?utm_source=menu&simple=true&next=https%3A%2F%2Fsportspredictcom.substack.com%2F';

export type GrandSlamResourceIcon = 'info' | 'scoring' | 'prize' | 'bot';

export interface GrandSlamResource {
	title: string;
	description: string;
	href: string;
	icon: GrandSlamResourceIcon;
	iconClassName: string;
	/** Custom uploaded icon URL from admin Resources config. */
	iconUrl?: string | null;
}

const GRAND_SLAM_RESOURCES = {
	info: {
		title: 'How it works',
		description: 'Challenge format breakdown',
		href: 'https://sportspredict.com/probability/grand-slam',
		icon: 'info',
		iconClassName: 'border-[#DCE3F9] bg-[#EEF2FF]',
	},
	scoring: {
		title: 'Scoring & Rules',
		description: 'Brier Points and eligibility',
		href: 'https://sportspredict.com/probability/grand-slam/scoring',
		icon: 'scoring',
		iconClassName: 'border-[#BDF4C3] bg-[#BDF4C3]/[0.64]',
	},
	prize: {
		title: 'Prizes',
		description: 'Prize tiers breakdown',
		href: 'https://sportspredict.com/probability/grand-slam#prize',
		icon: 'prize',
		iconClassName: 'border-[#E4D9FF] bg-[#E4D9FF]/[0.64]',
	},
	bot: {
		title: 'Bot setup',
		description: 'Configure your forecasting bot',
		href: BOT_SETUP_GUIDE_URL,
		icon: 'bot',
		iconClassName: 'border-[#F5E4AB] bg-[#F5E4AB]/[0.64]',
	},
} as const satisfies Record<GrandSlamResourceIcon, GrandSlamResource>;

/** Lucide stroke icons on prestart cards inherit color from the wrapper. */
export const GRAND_SLAM_RESOURCE_LUCIDE_CLASS = {
	info: 'text-[#5583F6]',
	scoring: 'text-[#198F58]',
	prize: 'text-[#8338EC]',
} as const satisfies Partial<Record<GrandSlamResourceIcon, string>>;

const PRESTART_RESOURCE_ORDER = ['info', 'scoring', 'prize'] as const;

export const PRESTART_RESOURCES = PRESTART_RESOURCE_ORDER.map((id) => GRAND_SLAM_RESOURCES[id]);
